module.exports = __webpack_public_path__ + "img/6h.7551ca1e.png";